import { AjaxStub, ErrorStub, AjaxEventHandler } from '@bingads-webui/instrumentation-stubs';
import { AjaxBulkUpsertEventHandler, AjaxCompositeEventHandler } from '@bingads-webui-campaign/campaign-ajax-handlers';
import { isInternalUrl } from '@bingads-webui/url-util';
import _ from 'underscore';
import { ExpectedUnhandledPromiseErrors } from './expected-unhandled-promise-errors';
import type { AjaxContext, SetStubOptions } from './types';

export function setStub({
  instrumentation,
  pageTrackingId,
  errorMappers,
  objectsToStub,
  ajaxStubOptions,
  lcid,
  serverContext,
}: SetStubOptions) {
  // If the application pulls in jQuery, stub it for ajax call.
  const filteredObjectsToStub = _.compact(objectsToStub);
  if (!_.isEmpty(filteredObjectsToStub)) {
    const shouldAddHeaders = (ajaxContext: AjaxContext) => isInternalUrl(ajaxContext.url);
    const ajaxEventHandler = new AjaxEventHandler({ errorMappers, shouldAddHeaders });
    let eventHandler: AjaxEventHandler | AjaxCompositeEventHandler = ajaxEventHandler;

    const isBulkUpsertTelemetryEnabled = serverContext && serverContext.DynamicPermissions && serverContext.DynamicPermissions.BulkUpsertTelemetry;
    if (isBulkUpsertTelemetryEnabled) {
      const bulkUpsertInstrumentation = instrumentation as ConstructorParameters<typeof AjaxBulkUpsertEventHandler>[0];
      const bulkUpsertEventHandler = new AjaxBulkUpsertEventHandler(bulkUpsertInstrumentation);
      eventHandler = new AjaxCompositeEventHandler([ajaxEventHandler, bulkUpsertEventHandler]);
    }

    const ajaxStub = new AjaxStub({
      stubOptions: {
        filteredObjectsToStub,
        pageTrackingId,
        lcid,
        ajaxStubOptions,
      },
      eventHandler,
      instrumentation,
    });

    ajaxStub.init();
  }

  const isExpectedUnhandledPromiseError = (errorMessage: string) => _.some(
    ExpectedUnhandledPromiseErrors,
    promiseError => errorMessage && errorMessage.toLowerCase().indexOf(promiseError) > -1
  );

  const logUnhandledPromiseRejections = serverContext && serverContext.DynamicPermissions && serverContext.DynamicPermissions.EnableLoggingForUnhandledPromiseRejections;
  const errorStub = new ErrorStub({
    instrumentation,
    logUnhandledPromiseRejections,
    isExpectedUnhandledPromiseError,
  });
  errorStub.init();
}
